import { ValidationRuleId } from '@/lib/graphql/generated/graphql';
import { effectiveValidationErrorsAtom } from '@/states/effective-validation-errors.state';
import { productsMapState } from '@/states/products.state';
import { atom } from 'jotai';

/**
 * IDs of the selected deal items whose validation errors include the
 * psychological price rule (`psychological_price_application`).
 *
 * These are exactly the deal items a one-click "recompute psychological
 * prices" action would correct. Only selected items are considered so the
 * count stays consistent with the errors surfaced in the table (excluded
 * items are not published and their errors are not shown).
 */
export const psychologicalPriceErrorItemIdsAtom = atom<string[]>((get) => {
  const errorMap = get(effectiveValidationErrorsAtom);
  const productsMap = get(productsMapState);
  const ids: string[] = [];

  for (const [id, errors] of errorMap) {
    if (!errors || errors.length === 0) continue;
    const activeVersion = productsMap.get(id)?.activeVersion;
    if (!activeVersion) continue;
    if (!activeVersion.isSelected) continue;

    const hasPsychologicalPriceError = errors.some(
      (error) => error.ruleId === ValidationRuleId.PsychologicalPriceApplication
    );
    if (hasPsychologicalPriceError) ids.push(id);
  }

  return ids;
});
